import { skipToken } from '@reduxjs/toolkit/query/react';

import type { CompanyMembersFilters } from '@/store/api/companyApi';
import type {
  CompanyMemberStatus,
  MembersTableSortDirection,
} from '@/store/api/userApi';

import {
  useGetCompanyMembersQuery,
  useGetCompanyQuery,
  useGetCompanySessionsQuery,
} from '@/store/api/companyApi';

// TODO: Make this consistent with other hooks
export const useCompany = (companyId: string) => {
  const {
    data: companyData,
    isLoading: isCompanyLoading,
    refetch: refetchCompany,
  } = useGetCompanyQuery(companyId || skipToken);

  return {
    companyData,
    isCompanyLoading,
    refetchCompany,
  };
};

export const useCompanyMembers = (
  companyId: string,
  // Undefined skips the request: nothing is selected in the Membership filter.
  companyMemberStatus: CompanyMemberStatus | undefined,
  page = 1,
  limit = 20,
  sortBy?: string,
  sortDirection?: MembersTableSortDirection,
  search?: string,
  filters?: CompanyMembersFilters,
) =>
  useGetCompanyMembersQuery(
    companyId && companyMemberStatus
      ? {
          companyId,
          companyMemberStatus,
          filters,
          limit,
          page,
          search,
          sortBy,
          sortDirection,
        }
      : skipToken,
  );

export const useCompanySessions = (companyId: string) =>
  useGetCompanySessionsQuery(companyId || skipToken);
